export default __webpack_public_path__ + "static/media/weather-cloud-2.8b6cfdbf.webp";